import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import { postNotification } from "../../../components/utilities/Notifications";
import { getParams } from "./util";
import { decodeToken } from "react-jwt";
import {
  findGetParameter,
  postData
} from "../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import { isAppMode } from "../../../global/AppOverlay";
import {
  getLocalStorage,
  removeLocalStorage
} from "../../../components/layout/cookies/CookieFunctions";

export default function OAuth2IDResponse(props) {
  const defaultUrl =
    props?.defaultUrl ||
    `${window.location.protocol}//${window.location.hostname}/`;

  const redirectUrl = getLocalStorage("bcpRedirectUrl")
    ? getLocalStorage("bcpRedirectUrl")
    : props?.redirectUrl;

  const [searchParams] = useSearchParams();
  const urlParams = getParams(searchParams);
  const exchangeTokenParam = findGetParameter("exchange_token");
  const codeParam = findGetParameter("code");
  const stateParam = findGetParameter("state")
    ? findGetParameter("state").replace(/=+$/, "")
    : null;

  const localState = getLocalStorage("bcpState")
    ? getLocalStorage("bcpState").replace(/=+$/, "")
    : null;

  const appMode = isAppMode();
  const navigate = useNavigate();

  const handleError = (error) => {
    postNotification("error", error || "Login error");
    setTimeout(() => {
      navigate("/");
    }, [3000]);
  };

  useEffect(() => {
    const onLoad = async () => {
      try {
        var id_token;
        var access_token;
        var refresh_token;

        // Check if the state is valid and matches the local state
        if (
          codeParam &&
          (!stateParam || !localState || stateParam !== localState)
        ) {
          handleError("Error logging in, please try again.");
          return;
        }

        if (codeParam && codeParam !== "") {
          try {
            const customUrl = getEnvironmentVariable("API");

            const apiToken = await postData(
              `/oauth/token`,
              {
                redirect_uri: defaultUrl,
                code: codeParam,
                grant_type: "authorization_code"
              },
              "APIUnsecured",
              null,
              customUrl
            );

            id_token = apiToken?.idToken;
            access_token = apiToken?.accessToken;
            refresh_token = apiToken?.refreshToken;
          } catch (err) {
            if (appMode) {
              return;
            } else {
              handleError(err);
              return;
            }
          }
        } else if (exchangeTokenParam) {
          try {
            const apiToken = await postData(`/users/exchangetoken`, {
              exchangeToken: exchangeTokenParam
            });

            id_token = apiToken?.idToken;
            access_token = apiToken?.accessToken;
            refresh_token = apiToken?.refreshToken;
          } catch (err) {
            if (appMode) {
              return;
            } else {
              handleError(err);
              return;
            }
          }
        } else {
          id_token = urlParams?.id_token;
          access_token = urlParams?.access_token;
          refresh_token = urlParams?.refresh_token;
        }

        removeLocalStorage("bcpRedirectUrl");
        removeLocalStorage("bcpState");

        if (id_token && access_token && refresh_token) {
          let identityToken = decodeToken(id_token);
          let authorisedUser =
            identityToken?.preferred_username || identityToken?.email;
          localStorage.setItem(
            `AuthIdentityServiceProvider.${getEnvironmentVariable(
              "AUTH_CLIENT_ID"
            )}.LastAuthUser`,
            authorisedUser
          );
          localStorage.setItem(
            `AuthIdentityServiceProvider.${getEnvironmentVariable(
              "AUTH_CLIENT_ID"
            )}.idToken`,
            id_token
          );
          localStorage.setItem(
            `AuthIdentityServiceProvider.${getEnvironmentVariable(
              "AUTH_CLIENT_ID"
            )}.accessToken`,
            access_token
          );
          localStorage.setItem(
            `AuthIdentityServiceProvider.${getEnvironmentVariable(
              "AUTH_CLIENT_ID"
            )}.refreshToken`,
            refresh_token
          );

          if (redirectUrl) {
            const url = new URL(redirectUrl);
            const params = new URLSearchParams(url.search);
            params.delete("code");
            params.delete("state");
            params.delete("exchange_token");

            // If the redirect URL is /login, redirect to the root URL
            if (url.pathname === "/login") {
              window.location.assign("/");
              return;
            }

            const newUrl = `${url.origin}${url.pathname}?${params.toString()}`;

            window.location.assign(newUrl);
            return;
          }

          window.location.assign("/");
        } else {
          handleError("Login error");
          return;
        }

        return;
      } catch (err) {
        postNotification("error", err);
      }
    };
    onLoad();
    // eslint-disable-next-line
  }, []);

  return <ModalLoadingFull />;
}
